import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

const TypeToConfirmModal = ({
  isOpen,
  title,
  body,
  confirmWord,
  inputLabel,
  cancelLabel,
  confirmLabel,
  processingLabel,
  isProcessing,
  onCancel,
  onConfirm,
  testId = "type-to-confirm-modal",
}) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (isOpen) setValue("");
  }, [isOpen]);

  const canConfirm = value === confirmWord && !isProcessing;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={isProcessing ? () => {} : onCancel}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                id={testId}
                className="w-full max-w-sm transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all"
              >
                <Dialog.Title as="h3" className="text-sm font-semibold text-gray-900">
                  {title}
                </Dialog.Title>
                <p className="text-xs text-gray-500 mt-2">{body}</p>
                <label
                  htmlFor={`${testId}-input`}
                  className="block mt-4 mb-2 text-xs font-medium text-gray-900"
                >
                  {inputLabel}
                </label>
                <input
                  id={`${testId}-input`}
                  type="text"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder={confirmWord}
                  autoComplete="off"
                  className="bg-gray-50 border border-gray-300 text-gray-600 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5"
                />
                <div className="mt-3 flex justify-end gap-2">
                  <button
                    type="button"
                    id={`${testId}-cancel`}
                    onClick={onCancel}
                    disabled={isProcessing}
                    className="py-2 px-4 text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 focus:outline-none disabled:opacity-50"
                  >
                    {cancelLabel}
                  </button>
                  <button
                    type="button"
                    id={`${testId}-confirm`}
                    onClick={onConfirm}
                    disabled={!canConfirm}
                    className="py-2 px-4 text-sm font-medium text-white bg-red-600 hover:bg-red-800 rounded-lg focus:outline-none focus:ring-4 focus:ring-red-300 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isProcessing ? processingLabel : confirmLabel}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default TypeToConfirmModal;
